import { useEffect, useState } from "react";
import API from "../../../../../services/api";

const initialState = {
  productName: "",
  description: "",
  category: "Rice",
  brand: "",
  price: "",
  offerPrice: "",
  stock: "",
  unit: "Kg",
  weight: "",
  image: null,
  isAvailable: true,
  isFeatured: false,
};

function useProvisionForm(selectedProduct, fetchProducts, closeModals) {
  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedProduct) {
      setFormData({
        productName: selectedProduct.productName || "",
        description: selectedProduct.description || "",
        category: selectedProduct.category || "Rice",
        brand: selectedProduct.brand || "",
        price: selectedProduct.price || "",
        offerPrice: selectedProduct.offerPrice || "",
        stock: selectedProduct.stock || "",
        unit: selectedProduct.unit || "Kg",
        weight: selectedProduct.weight || "",
        image: null,
        isAvailable: selectedProduct.isAvailable,
        isFeatured: selectedProduct.isFeatured,
      });
    } else {
      setFormData(initialState);
    }
  }, [selectedProduct]);

  const updateField = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const submitForm = async () => {
    try {
      setLoading(true);

      const body = new FormData();

      Object.keys(formData).forEach((key) => {
        if (
          formData[key] !== null &&
          formData[key] !== undefined
        ) {
          body.append(key, formData[key]);
        }
      });

      if (selectedProduct) {
        await API.put(
          `/provision/${selectedProduct._id}`,
          body
        );
      } else {
        await API.post("/provision", body);
      }

      await fetchProducts();

      closeModals();

      return true;

    } catch (err) {
      console.error("Provision Save Error:", err);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    loading,
    updateField,
    submitForm,
  };
}

export default useProvisionForm;